import { Controller } from "@hotwired/stimulus"

// モバイルでのサイドバー開閉。デスクトップ（md以上）は常時表示。
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  // メニュー項目クリック時はモバイルで閉じる（md未満のときのみ）
  close() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      this.panelTarget.classList.add("hidden")
    }
  }
}
